module.exports = __webpack_public_path__ + "favicon/favicon_70.a71d3d28.png";